<template>
  <div class="bg-container page">
      <img class="bg-img" src="img/login/login-bg.png">
      <div class="bg-wrapper">
        <div class="login">
          <van-nav-bar class="nav-bar">
            <template #left>
              <van-icon name="arrow-left" color="#fff" @click="back()"/>
            </template>
            <template #right>
              <LangSwitch class="nav-right" />
            </template>
          </van-nav-bar>
          <div class="wrapper">
            <div class="logo-container">
              <div class="logo-wrapper">
                <img class="logo-img" :src="this.$store.getters.getBaseInfo.ico !==undefined ?this.$store.getters.getBaseInfo.ico:'/img/null.png'">
              </div>
            </div>
            <div class="title">{{ $t('login.title') }}</div>
            <div class="loginForm">
              <van-field v-model="username"  clearable input-align="center" class="input"  :placeholder="$t('login.usernamePlaceholder')" />
              <van-field
                  v-model="password"
                  :type="passwordType"
                  input-align="center"
                  class="input"
                  :placeholder="$t('login.passwordPlaceholder')">
                <template slot="right-icon">
                  <van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType"/>
                </template>
              </van-field>
              <div class="captcha-row">
                <van-field v-model="captcha_code" clearable input-align="center" class="input"
                  :placeholder="$t('captcha.placeholder')" />
                <img :src="captcha_img" class="captcha-img" :alt="$t('captcha.refresh')" @click="loadCaptcha()" />
              </div>
              <div class="reset-text">
                <span>{{ $t('login.forgotPassword') }}</span>
              </div>
              <div @click="toRegister()" class="register-text">
                <span>{{ $t('login.noAccountRegister') }}</span>
              </div>
              <van-button class="login-btn"   type="primary" size="normal" @click="doLogin()">{{ $t('login.submit') }}</van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import LangSwitch from '../../components/LangSwitch.vue'

export default {
  components: { LangSwitch },
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      username: '',
      password: this.inputValue,
      passwordType: 'password',
      captcha_id: 0,
      captcha_code: '',
      captcha_img: '',
    };
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    toRegister(){
      this.$router.push("Register")
    },
    loadCaptcha() {
      this.$http({
        method: 'get',
        url: 'captcha_generate'
      }).then(res => {
        if (res.code === 200) {
          this.captcha_id = res.data.captcha_id;
          this.captcha_img = res.data.img;
          this.captcha_code = '';
        }
      });
    },
    doLogin() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast(this.$t('common.usernameRequired'));
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast(this.$t('common.passwordRequired'));
        return false;
      }
      if(this.captcha_code === "" || this.captcha_code === null || this.captcha_code === undefined){
        this.$toast(this.$t('captcha.required'));
        return false;
      }
      this.$http({
        method: 'get',
        data:{username:this.username,password:this.password,captcha_id:this.captcha_id,captcha_code:this.captcha_code},
        url: 'member_login'
      }).then(res=>{
          if(res.code === 200){
            this.$toast.success(res.msg);
            localStorage.setItem('token',res.data.id)
            this.$router.push("Mine")
          }else {
            this.$toast(res.msg);
            if(res.code === 401){
              this.loadCaptcha();
            }
          }
      })
    }
  },
  created() {
      if(localStorage.getItem('token')){
        return window.history.back();
      }
      this.loadCaptcha();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.login{
  height: 100%;
}
.bg-container .bg-wrapper .login .nav-bar{
  background: 0 0
}

.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container{
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper{
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.login .wrapper .title{
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}
.login .wrapper .loginForm{
  padding: 60px;
}
.login .wrapper .loginForm .input{
  padding: 10px 20px;
  margin-top: 40px;
  border-radius: 50px;
  text-align: center;
  line-height: 80px;
  font-size: 30px;
  color: #4e4e4e;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-icon {
  font-size: 50px;
}
/* 尺寸按 750 设计稿（postcss px→vw，viewportWidth=750）。对照本页输入框
   行高 100px/字号 50px 的尺度，验证码图同高 100px，宽 260px
   ≈ 图片源 120x44 的 2.2 倍，清晰不糊 */
.captcha-row { display: flex; align-items: center; }
.captcha-img { height: 100px; width: 260px; margin-left: 20px; cursor: pointer; border-radius: 6px; border: 1px solid #ddd; }
.login .wrapper .loginForm .reset-text{
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.login .wrapper .loginForm .reset-text span{
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}
.login .wrapper .loginForm .register-text{
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .wrapper .loginForm .register-text span{
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}
.login .wrapper .loginForm .active{

}
.login .wrapper .loginForm .login-btn{
  margin-top: 85px;
  width: 100%;
  height: 100px;
  border-radius: 50px;
  color: #fff;
  background-color: #7e5678;
  font-size: 30px;
  font-weight: bolder;
  border: none;
}

</style>
